import { useEffect } from 'react';
import { ResponsiveCalendar } from '@/components/responsiveCalendar/responsiveCalendar';

interface CalendarDateLabelInterface {
  month: Date;
  setMonth: (date: Date) => void;
  setAllDays: (dates: Date[]) => void;
}

export const CalendarDateLabel = ({
  month,
  setMonth,
  setAllDays,
}: CalendarDateLabelInterface) => {
  const generateFutureDays = () => {
    var date = new Date(month.getFullYear(), month.getMonth(), 1);
    if (month.getMonth() === new Date().getMonth()) date = new Date();
    var days = [];
    while (date.getMonth() === month.getMonth()) {
      days.push(new Date(date));
      date.setDate(date.getDate() + 1);
    }
    return days;
  };

  useEffect(() => {
    setAllDays(generateFutureDays());
  }, [month]);

  return (
    <ResponsiveCalendar
      value={month}
      views={['year', 'month']}
      minDate={new Date()}
      maxDate={new Date(new Date().setMonth(new Date().getMonth() + 10))}
      setOnChange={(newValue: Date | null) => {
        if (newValue == null) {
          return;
        }
        setMonth(newValue);
      }}
      useDefault={false}
    />
  );
};
